import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function TransactionReportsScreen() {
  return (
    <PlaceholderScreen
      icon="🧾"
      title="Transaction Reports"
      subtitle="This report shows filterable transaction history across all accounts. This report will be available in a future update."
    />
  )
}
